import React, { useEffect, useMemo, useState } from "react";
import { listClasses, listStaff, autoLockTeacherWeek, TEACHER_DEPARTMENT } from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";

// (22/10/2026) "Xếp tay lại cả lớp": chọn 1 hay vài lớp -> giải CHUNG mọi GV đang được xếp tay ở các lớp đó (chỉ trong
// các lớp đó; tiết của họ ở lớp khác giữ nguyên) để các GV nhường ô cho nhau — dùng khi "Tự xếp tay" 1 GV bị thiếu
// tiết vì lớp đã kín ô bởi tiết xếp tay của GV khác. Bấm "Xem trước" (không ghi) rồi "Áp dụng".
const DAYS = ["T2", "T3", "T4", "T5", "T6", "T7"];
const khoiOf = (n) => (String(n || "").match(/^\d+/) || [""])[0];

const HappySchoolClassRelock = ({ weekId }) => {
  const schoolId = getActiveSchoolId();
  const [classes, setClasses] = useState([]);
  const [staffName, setStaffName] = useState({});
  const [picked, setPicked] = useState([]);
  const [khoi, setKhoi] = useState("");
  const [busy, setBusy] = useState("");
  const [result, setResult] = useState(null); // { dryRun, json }
  const [error, setError] = useState("");

  useEffect(() => {
    if (!schoolId) return;
    listClasses(schoolId).then((c) => setClasses((c || []).filter((x) => /^1[012]A/.test(x.name) && x.status !== "giai_tan").sort((a, b) => a.name.localeCompare(b.name, "vi", { numeric: true })))).catch((e) => setError(e.message));
    listStaff(schoolId, { department: TEACHER_DEPARTMENT }).then((t) => setStaffName(Object.fromEntries((t || []).map((x) => [x.id, x.name])))).catch(() => {});
  }, [schoolId]);
  useEffect(() => { setResult(null); }, [picked, weekId]);

  const shown = useMemo(() => classes.filter((c) => !khoi || khoiOf(c.name) === khoi), [classes, khoi]);
  const className = useMemo(() => Object.fromEntries(classes.map((c) => [c.id, c.name])), [classes]);
  const toggle = (id) => setPicked((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));

  const run = async (dryRun) => {
    if (!picked.length) return;
    if (!dryRun && !window.confirm(`Xếp tay lại chung cho ${picked.length} lớp: ${picked.map((id) => className[id]).join(", ")}?\nCác tiết xếp tay hiện có của các GV này TRONG các lớp đó sẽ được xếp lại.`)) return;
    setBusy(dryRun ? "preview" : "apply");
    setError("");
    try {
      const json = await autoLockTeacherWeek(schoolId, weekId, { wholeClassIds: picked, replace: true, dryRun });
      setResult({ dryRun, json });
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy("");
    }
  };

  if (!weekId) return <p style={{ color: "#6b7280" }}>Chưa chọn tuần TKB.</p>;
  const j = result && result.json;
  const created = (j && j.created) || [];
  const byClass = {};
  created.forEach((l) => { (byClass[l.classId] = byClass[l.classId] || []).push(l); });

  return (
    <div>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Dùng khi <b>Tự xếp tay</b> 1 GV bị thiếu tiết vì lớp đã kín ô bởi tiết xếp tay của GV khác. Chọn lớp → bộ xếp sắp lại
        <b> chung</b> mọi GV đang được xếp tay ở lớp đó để nhường ô cho nhau. Tiết của các GV này ở <b>lớp khác</b> giữ nguyên.
        Bấm <b>Xem trước</b> (chưa ghi), ổn thì bấm <b>Áp dụng</b>.
      </p>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
        {["", "12", "11", "10"].map((k) => (
          <button key={k || "all"} type="button" onClick={() => setKhoi(k)} style={khoi === k ? chipOn : chip}>{k ? `Khối ${k}` : "Tất cả"}</button>
        ))}
        {picked.length > 0 && <button type="button" onClick={() => setPicked([])} style={chip}>Bỏ chọn ({picked.length})</button>}
      </div>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 12 }}>
        {shown.map((c) => (
          <button key={c.id} type="button" onClick={() => toggle(c.id)} style={picked.includes(c.id) ? clsOn : cls}>{c.name}</button>
        ))}
      </div>
      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        <button type="button" disabled={!picked.length || !!busy} onClick={() => run(true)} style={btnGhost}>{busy === "preview" ? "Đang xếp thử..." : "👁 Xem trước"}</button>
        <button type="button" disabled={!picked.length || !!busy} onClick={() => run(false)} style={btn}>{busy === "apply" ? "Đang xếp..." : "✅ Áp dụng"}</button>
      </div>
      {error && <p style={{ color: "#dc2626" }}>{error}</p>}
      {j && (
        <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: 12 }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>
            {result.dryRun ? "👁 Xem trước (chưa ghi)" : "✅ Đã áp dụng"} — {created.length} ô xếp tay
            {Array.isArray(j.removed) ? ` (thay ${j.removed.length} ô cũ)` : ""}
          </div>
          {(j.shortages || []).length === 0 ? (
            <div style={{ color: "#166534", fontWeight: 600, marginBottom: 6 }}>✓ Đủ tiết hết, không lớp-môn nào thiếu.</div>
          ) : (
            <div style={{ color: "#b91c1c", marginBottom: 6 }}>
              Còn thiếu: {(j.shortages || []).map((x) => `${x.className} ${x.subjectName} (${staffName[x.teacherId] || ""}) ${x.placed}/${x.need}`).join("; ")}
            </div>
          )}
          {(j.warnings || []).length > 0 && (
            <div style={{ color: "#92400e", fontSize: 12, marginBottom: 6 }}>{(j.warnings || []).map((w, i) => <div key={i}>⚠ {typeof w === "string" ? w : JSON.stringify(w)}</div>)}</div>
          )}
          {picked.map((cid) => {
            const items = (byClass[cid] || []).slice().sort((a, b) => a.day - b.day || a.period - b.period);
            const grid = {};
            items.forEach((l) => { grid[`${l.day}|${l.period}`] = l; });
            return (
              <div key={cid} style={{ marginTop: 10 }}>
                <div style={{ fontWeight: 700 }}>{className[cid]}</div>
                <table style={{ borderCollapse: "collapse", fontSize: 12 }}>
                  <thead><tr><th style={th}></th>{DAYS.map((d) => <th key={d} style={th}>{d}</th>)}</tr></thead>
                  <tbody>
                    {Array.from({ length: 10 }, (_, p) => (
                      <tr key={p} style={p === 5 ? { borderTop: "2px solid #374151" } : {}}>
                        <td style={{ ...td, fontWeight: 600 }}>{p < 5 ? "S" : "C"}{(p % 5) + 1}</td>
                        {DAYS.map((_, d) => {
                          const l = grid[`${d}|${p}`];
                          return <td key={d} style={{ ...td, background: l ? "#eff6ff" : "#fff" }}>{l ? <>{l.subjectName || ""}<div style={{ color: "#6b7280", fontSize: 10 }}>{(staffName[l.teacherId] || "").split(" ").slice(-2).join(" ")}</div></> : ""}</td>;
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

const chip = { padding: "5px 12px", background: "#fff", color: "#374151", border: "1px solid #d1d5db", borderRadius: 14, cursor: "pointer", fontWeight: 600, fontSize: 12 };
const chipOn = { ...chip, background: "#0ea5a3", color: "#fff", border: "1px solid #0ea5a3" };
const cls = { padding: "6px 10px", background: "#fff", color: "#1f2937", border: "1px solid #cbd5e1", borderRadius: 6, cursor: "pointer", fontSize: 13, minWidth: 56 };
const clsOn = { ...cls, background: "#1d4ed8", color: "#fff", border: "1px solid #1d4ed8", fontWeight: 700 };
const btn = { padding: "8px 16px", background: "#16a34a", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 600 };
const btnGhost = { ...btn, background: "#fff", color: "#0f766e", border: "1px solid #99f6e4" };
const th = { border: "1px solid #e5e7eb", padding: "3px 6px", background: "#f9fafb", minWidth: 70 };
const td = { border: "1px solid #e5e7eb", padding: "2px 4px", textAlign: "center", verticalAlign: "top", height: 28 };

export default HappySchoolClassRelock;
